// extracted by mini-css-extract-plugin
export default {"container":"EmailQueueSubtitle_container__x1qtu","separator":"EmailQueueSubtitle_separator__ee5GP"};